import VueDragSelect from "@coleqiu/vue-drag-select";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueDragSelect);
});
